import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Lead.module.css";
import { Link } from "react-router-dom";
import { MdDelete, MdSearch, MdClose } from "react-icons/md";
import LeadApi from "../../services/LeadApi";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import Paginacao from "../../components/paginacao/Paginacao";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaUserCheck } from "react-icons/fa";
import UsuarioApi from "../../services/UsuarioApi";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Lead() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    // Modais
    const [mostarModalDeletar, setMostarModalDeletar] = useState(false);
    const [mostarModalEnviarMenssagem, setMostarModalEnviarMenssagem] = useState(false);
    const [mostarModalTransformar, setMostarModalTransformar] = useState(false);

    // Estado da tabela, paginação e filtro
    const [leads, setLeads] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState(0);

    const [nomeFiltro, setNomeFiltro] = useState("");
    const [emailFiltro, setEmailFiltro] = useState("");
    const [origemFiltro, setOrigemFiltro] = useState("");
    const [periodoFiltro, setPeriodoFiltro] = useState("");
    const [paginaAtual, setPaginaAtual] = useState(1);

    // Alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    // Lead selecionado para ações
    const [leadSelecionado, setLeadSelecionado] = useState(null);

    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState(null);

    // Dados para seleção de período
    const periodoBusca = [
        { key: 'Manha', periodo: 'Manhã' },
        { key: 'Tarde', periodo: 'Tarde' },
        { key: 'Noturno', periodo: 'Noturno' },
        { key: 'Online', periodo: 'Online' }
    ];

    // Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    // Função para formatar telefone
    const formatarTelefone = (telefone) => {
        if (!telefone) return "";

        const numeros = telefone.replace(/\D/g, "");

        if (numeros.length === 11) {
            return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
        } else if (numeros.length === 10) {
            return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
        }
        return telefone;
    };

    // Modais abrir
    const handleClickDeletar = (lead) => {
        setLeadSelecionado(lead);
        setMostarModalDeletar(true);
    };

    const handleClickEnviarMenssagem = (lead) => {
        setLeadSelecionado(lead);
        setMostarModalEnviarMenssagem(true);
    };

    const handleClickTransformar = (lead) => {
        setLeadSelecionado(lead);
        setMostarModalTransformar(true);
    };

    // Ações de modais
    const handleDeletar = async () => {
        try {
            await LeadApi.deletarLeadAsync(leadSelecionado.id);
            setLeads(leads.filter((l) => l.id !== leadSelecionado.id));
            setMensagemAlerta(`Lead deletado com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta();
        } catch (error) {
            setMensagemAlerta(`Erro ao deletar lead: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta();
        } finally {
            handleFecharModal();
        }
    };

    const handleEnviarMensagem = async () => {
        try {
            setLoading(true);
            if (!leadSelecionado?.telefone || !mensagem) {
                setMensagemAlerta("Número de telefone ou mensagem inválidos.");
                setTipoAlerta("danger");
                exibirAlerta();
                return;
            }
            const numeroFormatado = leadSelecionado.telefone.replace(/\D/g, "");
            const mensagemFormatada = encodeURIComponent(mensagem);
            const linkWhatsApp = `https://api.whatsapp.com/send?phone=${numeroFormatado}&text=${mensagemFormatada}`;
            window.open(linkWhatsApp, "_blank");
        } catch (error) {
            setMensagemAlerta(`Erro ao enviar mensagem para o whatsapp: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta();
        } finally {
            handleFecharModal();
            setLoading(false);
        }
    };

    const handleTransformar = async () => {
        try {
            setLoading(true);
            await UsuarioApi.TransformarLeadEmUsuarioAsync(leadSelecionado.nome, leadSelecionado.email, leadSelecionado.id);
            setLeads(leads.filter((l) => l.id !== leadSelecionado.id));
            setMensagemAlerta(`Lead transformado em usuário com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta();
        } catch (error) {
            setMensagemAlerta(`Erro ao transformar lead em usuário: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta();
        } finally {
            handleFecharModal();
            setLoading(false);
        }
    };

    const handleFecharModal = () => {
        setMostarModalDeletar(false);
        setMostarModalEnviarMenssagem(false);
        setMostarModalTransformar(false);
        setLeadSelecionado(null);
        setMensagem(null);
    };

    // Paginação e filtros

    async function CarregarLeads(pagina, nomeBusca, emailBusca, origemBusca, periodoBusca) {
        try {
            const listaLeads = await LeadApi.ListarLeadsComPaginacaoAsync(
                pagina,
                nomeBusca,
                emailBusca,
                origemBusca,
                periodoBusca
            );
            setQuantidadeItens(listaLeads.quantidadeRegistros);
            setLeads(listaLeads.registros);
        } catch (error) {
            console.error("Erro ao carregar leads:", error.response?.data || error.message);
        }
    }

    async function BuscarLeads() {
        setPaginaAtual(1);
        await CarregarLeads(1, nomeFiltro, emailFiltro, origemFiltro, periodoFiltro);
    }

    async function ResetarLeads() {
        setNomeFiltro("");
        setEmailFiltro("");
        setOrigemFiltro("");
        setPeriodoFiltro("");
        setPaginaAtual(1);
        await CarregarLeads(1, "", "", "", "");
    }

    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        await CarregarLeads(paginaNova, nomeFiltro, emailFiltro, origemFiltro, periodoFiltro);
    }

    const totalPages = Math.ceil(quantidadeItens / 30);

    useEffect(() => {
        CarregarLeads(1, nomeFiltro, emailFiltro, origemFiltro, periodoFiltro);
    }, []);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Leads</h4>
                    </div>

                    <div className={style.container_filtro}>
                        <InputBuscar
                            type="text"
                            id="hidenNome"
                            placeholder="Nome"
                            name="nome"
                            maxLength={30}
                            value={nomeFiltro}
                            onChange={(e) => setNomeFiltro(e.target.value)}
                        />
                        <InputBuscar
                            type="text"
                            id="hidenEmail"
                            placeholder="Email"
                            name="email"
                            maxLength={50}
                            value={emailFiltro}
                            onChange={(e) => setEmailFiltro(e.target.value)}
                        />
                        <InputBuscar
                            type="text"
                            id="hidenOrigem"
                            placeholder="Origem"
                            name="origem"
                            maxLength={15}
                            value={origemFiltro}
                            onChange={(e) => setOrigemFiltro(e.target.value)}
                        />
                        <Form.Select
                            id="hidenOrigem"
                            name="periodo"
                            value={periodoFiltro}
                            onChange={(e) => setPeriodoFiltro(e.target.value)}
                        >
                            <option>Período</option>
                            {periodoBusca.map((item) => (
                                <option key={item.key} value={item.key}>
                                    {item.periodo}
                                </option>
                            ))}
                        </Form.Select>
                        <div className={style.container_filtro2}>
                            <Button onClick={BuscarLeads} id={style.botao_buscar}>
                                <MdSearch /> Buscar
                            </Button>
                            <Button onClick={ResetarLeads} id={style.botao_resetar}>
                                <MdClose /> Limpar
                            </Button>
                        </div>
                    </div>

                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Telefone</th>
                                        <th>Origem</th>
                                        <th>Período</th>
                                        <th className={style.coluna_acoes_titulo}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {leads.map((lead) => (
                                        <tr className={style.tabela_corpo} key={lead.id || lead.ID || lead.Id}>
                                            <td title={lead.nome || lead.Nome}>{lead.nome || lead.Nome}</td>
                                            <td title={lead.email || lead.Email}>{lead.email || lead.Email}</td>
                                            <td title={lead.telefone || lead.Telefone}>
                                                {formatarTelefone(lead.telefone || lead.Telefone)}
                                            </td>
                                            <td title={lead.origem || lead.Origem}>{lead.origem || lead.Origem}</td>
                                            <td title={lead.periodo || lead.Periodo}>{lead.periodo || lead.Periodo}</td>
                                            <td className={style.coluna_acoes}>
                                                <Link
                                                    onClick={() => handleClickEnviarMenssagem(lead)}
                                                    className={style.botao_wpp}
                                                >
                                                    <IoLogoWhatsapp title="Whatsapp" />
                                                </Link>
                                                <Link
                                                    onClick={() => handleClickTransformar(lead)}
                                                    className={style.botao_user}
                                                >
                                                    <FaUserCheck title="Transformar" />
                                                </Link>
                                                <Link
                                                    onClick={() => handleClickDeletar(lead)}
                                                    className={style.botao_deletar}
                                                >
                                                    <MdDelete title="Deletar" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPages}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />
                    </div>

                    {/* Modais */}

                    <Modal show={mostarModalDeletar} onHide={handleFecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Tem certeza que deseja deletar o lead {leadSelecionado?.nome}?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleFecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="danger" onClick={handleDeletar}>
                                Deletar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={mostarModalEnviarMenssagem} onHide={handleFecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Enviar mensagem via Whatsapp</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group controlId="formMensagem" className="mb-3">
                                    <Form.Label>
                                        Escreva a mensagem que deseja enviar para {leadSelecionado?.nome}:
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Digite a mensagem"
                                        name="mensagem"
                                        value={mensagem}
                                        onChange={(e) => setMensagem(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleFecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="success" onClick={handleEnviarMensagem}>
                                Enviar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={mostarModalTransformar} onHide={handleFecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Tem certeza que deseja transformar o lead {leadSelecionado?.nome} em aluno?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleFecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="success" onClick={handleTransformar}>
                                Confirmar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Topbar>
        </Sidebar>
    );
}

export default Lead;
